import {
  all,
  call,
  delay,
  put,
  select,
  take,
  throttle,
} from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  dataForUserSettingsAccepted,
  dataForUserSettingsRejected,
} from '../../actions/userObject/settings/requestFetchUserSettings'
import { fetchSettings } from '../../models/Object'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import { UserSettingsActions } from '../../reducers/userObject/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* loadSettingsFromService(action) {
  const calendarId = yield select(getCalendarId)

  if (!calendarId) {
    yield delay(200)
    return yield put(action)
  }

  try {
    const actionNames = fetchActionsName(ActionNames.LoadSettings)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, fetchSettings)),
    ])

    const settings = yield call(service, calendarId)
    yield put(dataForUserSettingsAccepted(settings))
  } catch (e) {
    yield put(dataForUserSettingsRejected(e.message))
  }
}

export default function*() {
  // yield takeLatest(AuthorizationActions.AuthorizationGranted, loadSettings)
  // yield takeLatest(RoomActions.RequestDataForRooms, loadSettingsFromService)
  yield throttle(
    500,
    UserSettingsActions.RequestDataForUserSettings,
    loadSettingsFromService,
  )
}
